import { authenticatedApi } from "@/lib/api";

export const sniimAlertsApi = {
    dashboard: (params) => authenticatedApi.get("/sniim/dashboard", { params }),
    recordDashboardActivity: (payload) => authenticatedApi.post("/sniim/dashboard/activity", payload),
    productStatus: (slug) => authenticatedApi.get(`/sniim/products/${encodeURIComponent(slug)}/status`),
    save: (payload) => authenticatedApi.post("/sniim/watchlist", payload),
    listWatchlist: (params) => authenticatedApi.get("/sniim/watchlist", { params }),
    updateWatch: (id, payload) => authenticatedApi.patch(`/sniim/watchlist/${id}`, payload),
    removeWatch: (id, alertAction) => authenticatedApi.delete(`/sniim/watchlist/${id}`, { params: { alert_action: alertAction } }),
    listAlerts: (params) => authenticatedApi.get("/sniim/alerts", { params }),
    createAlert: (payload) => authenticatedApi.post("/sniim/alerts", payload),
    updateAlert: (id, payload) => authenticatedApi.patch(`/sniim/alerts/${id}`, payload),
    deleteAlert: (id) => authenticatedApi.delete(`/sniim/alerts/${id}`),
    history: (params) => authenticatedApi.get("/sniim/alert-history", { params }),
    dismissEvent: (id) => authenticatedApi.post(`/sniim/alert-history/${id}/dismiss`),
    preferences: () => authenticatedApi.get("/sniim/preferences"),
    savePreferences: (payload) => authenticatedApi.put("/sniim/preferences", payload),
};

export const PERSONAL_DASHBOARD_ENABLED =
    process.env.REACT_APP_SNIIM_PERSONAL_DASHBOARD_ENABLED === "true";
